<app-top-navbar></app-top-navbar>

<div class="content">
  <div class="contact-card">
    <h2 class="mb-4" style="text-align: center">
      Compare Competitors Solutions
    </h2>
    <div class="pricing-table-container">
      <table class="table pricing-table">
        <thead>
          <tr>
            <th scope="col" class="feature-col"></th>
            @for (plan of plans; track plan) {
              <th
                scope="col"
                [class.highlight]="plan.highlight"
                class="text-center plan-col"
                >
                <div class="plan-name">{{ plan.name }}</div>
                <div class="plan-price">{{ plan.price }}</div>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (feature of features; track feature) {
            <tr>
              <td class="feature-name">{{ feature.name }}</td>
              @for (plan of plans; track plan) {
                <td class="text-center">
                  @switch (getDisplayType(getValue(feature, plan.name))) {
                    @case ('check') {
                      <i
                        class="fas fa-check text-success"
                      ></i>
                    }
                    @case ('cross') {
                      <i class="fas fa-times text-danger"></i>
                    }
                    @case ('text') {
                      <small
                        class="text-success font-weight-bold"
                        >
                        {{ getValue(feature, plan.name) }}
                      </small>
                    }
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-bottom-footer></app-bottom-footer>
